import { Divider as ChakraDivider, DividerProps } from "@chakra-ui/react";
import React from "react";

const Divider = ({ ...props }: DividerProps) => {
  return <ChakraDivider {...props} />;
};

export default Divider;
